import { authorize } from '@/admin/api/common';
import handleError from '@/actions/common/handle-error.action';

export default async function (): Promise<boolean> {
  let isSuperuser = false;
  try {
    await authorize();
    isSuperuser = true;
  } catch (error) {
    handleError(error);
  }

  return isSuperuser;
};